import { Grid, useMediaQuery, Typography, Box } from '@material-ui/core';
import React from 'react';

import PropTypes from 'prop-types';

import EventsFilterMobile from './EventsFilterMobile';
import EventsFilterDesktop from './EventsFilterDesktop';
import { useEvents, useOrganizations } from 'hooks';
import { useTranslation } from 'react-i18next';

import { CardContent } from '@mui/material';

const EventsFilter = ({ isOpen, toggleFilter, setRedirectEvents }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const { t } = useTranslation();
  const { fetchEvents, filters, setFilter, clearFilter } = useEvents();
  const { selectedOrganizationId } = useOrganizations();

  const restoreDefaultFilters = () => {
    const defaultFilters = {
      type: '',
      layer: '',
      layer_id: '',
      time_start: '',
      time_end: '',
      search: filters.search,
      organization_id: selectedOrganizationId !== undefined ? selectedOrganizationId : '',
    };

    clearFilter();
    setFilter(defaultFilters);
    fetchEvents(defaultFilters);
    setRedirectEvents(false);
  };

  /**
   *
   * @param {object} filter
   * @example { layer: "field", start_date: "2021-10-01", end_date: "2021-10-31", layer_id: "x"}
   * @returns none
   */
  const submitFilter = (filter) => {
    let currentFilters = filters;
    currentFilters = { ...filters, ...filter };
    setRedirectEvents(false);
    fetchEvents(currentFilters);
    setFilter(filter);
  };

  return (
    <Grid item container direction="row">
      {isMobile && (
        <Box>
          <EventsFilterMobile
            restoreDefaultFilters={restoreDefaultFilters}
            submitFilter={submitFilter}
            isOpen={isOpen}
            toggleFilter={toggleFilter}
          ></EventsFilterMobile>
        </Box>
      )}
      {!isMobile && (
        <Box>
          <CardContent>
            <Typography variant="h2">{t('filters')}</Typography>
          </CardContent>
          <EventsFilterDesktop
            restoreDefaultFilters={restoreDefaultFilters}
            submitFilter={submitFilter}
          ></EventsFilterDesktop>
        </Box>
      )}
    </Grid>
  );
};

EventsFilter.propTypes = {
  isOpen: PropTypes.bool,
  toggleFilter: PropTypes.func,
  setRedirectEvents: PropTypes.func,
};
EventsFilter.defaultProps = {
  isOpen: true,
  toggleFilter: () => {},
  setRedirectEvents: () => {},
};

export default EventsFilter;
